import type { ChangeEvent, ChangeEventHandler } from 'react';

/**
 * Updates a controlled input/textarea so React parents receive a consistent `target.value`
 * (plain synthetic `{ target: { value } }` is not always applied reliably for controlled components).
 */
export function applyControlledFieldValue(
  el: HTMLInputElement | HTMLTextAreaElement,
  next: string,
  onChange?: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>
): void {
  const proto = el instanceof HTMLTextAreaElement ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype;
  const setter = Object.getOwnPropertyDescriptor(proto, 'value')?.set;
  setter?.call(el, next);
  onChange?.({ target: el, currentTarget: el } as ChangeEvent<HTMLInputElement | HTMLTextAreaElement>);
}
